import { useState } from "react";
import { Modal } from 'flowbite-react'
import { BsHandThumbsUp } from 'react-icons/bs'
import emailjs from '@emailjs/browser'

export default function ContactForm () {


    const [ formData, setFormData ] = useState({
        name:'',
        email:'',
        phone:'',
        subject:'',
        message:''
    })

    const handleChange = (event) => {
        setFormData({...formData, [event.target.id]: event.target.value})
    }

    const [ showConfirm, setShowConfirm ] = useState(false)

    const toggleModal = () => {
        setShowConfirm(!showConfirm)

    }

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.send(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, formData, process.env.REACT_APP_EMAILJS_PUBLIC_KEY)
        .then((result) => {
            setFormData({
                name:'',
                email:'',
                phone:'',
                subject:'',
                message:''
            })
            console.log(result.text);
            console.log('message sent')
            toggleModal()

        }, (error) => {
            console.log(error.text);
        });
    };

    
    return (
        <div className="contact-form" id="contact">

        <section className="bg-gradient-to-br from-gray-900 via-gray-700 to-gray-900 dark:bg-gray-900">
            <div className="py-8 mb-4 lg:py-16 px-4 mx-auto max-w-screen-md">
                <h2 className="mb-4 mt-8 text-3xl lg:text-4xl tracking-tight font-extrabold text-center text-white lg:tracking-wide dark:text-white">Let's Connect</h2>
                <p className="mb-8 lg:mb-12 font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl">Want to collaborate? Or just connect? Get in touch.</p>
                <form onSubmit={sendEmail} className="mb-8 space-y-8">
                    <div>
                        <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-300 dark:text-gray-300">Your Name</label>
                        <input type="text" id="name" name="user_name" onChange={handleChange} value={formData.name}className="shadow-sm-light bg-gray-700 border border-gray-600 text-white text-sm rounded-lg placeholder-gray-400 focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="name" required/>
                    </div>
                    <div>
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-300 dark:text-gray-300">Your email</label>
                        <input type="email" id="email" name="user_email" onChange={handleChange} value={formData.email}className="shadow-sm-light bg-gray-700 border border-gray-600 text-white text-sm rounded-lg placeholder-gray-400 focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="name@email.com" required/>
                    </div>
                    <div>
                        <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-300 dark:text-gray-300">Your Phone #</label>
                        <input type="text" id="phone" name="user_phone" onChange={handleChange} value={formData.phone}className="shadow-sm-light bg-gray-700 border border-gray-600 text-white text-sm rounded-lg placeholder-gray-400 focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="123-456-7890" />
                    </div>
                    <div>
                        <label htmlFor="subject" className="block mb-2 text-sm font-medium text-gray-300 dark:text-gray-300">Subject</label>
                        <input type="text" id="subject" name="subject" onChange={handleChange} value={formData.subject}className="block p-3 w-full text-sm text-white bg-gray-700 rounded-lg border border-gray-600 placeholder-gray-400 shadow-sm-light focus:ring-green-500 focus:border-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="Let me know how I can help" required />
                    </div>
                    <div className="sm:col-span-2">
                        <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-300 dark:text-gray-400">Your message</label>
                        <textarea id="message" rows="6" name="message" onChange={handleChange} value={formData.message}className="block p-2.5 w-full text-sm text-white bg-gray-700 rounded-lg shadow-sm-light placeholder-gray-400 border border-gray-600 focus:ring-green-500 focus:border-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Write a message..."></textarea>
                    </div>
                    <div className="flex justify-center">
                    <button type="submit" className="py-3 mb-4 px-5  text-sm font-medium text-center text-white rounded-lg bg-green-500  sm:w-fit hover:bg-green-600 focus:ring-2 focus:outline-none focus:ring-green-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Send message</button>
                    </div>
                </form>
            </div>
        </section>
        <>
            <Modal
                show={showConfirm}
                size="md"
                popup={true}
                onClose={toggleModal}
                className="bg-gray-700"
            >
                <Modal.Header className="bg-gray-700" />
                <Modal.Body className="bg-gray-700">
                <div className="text-center">
                    <BsHandThumbsUp className="mx-auto mb-4 h-14 w-14 text-green-500 dark:text-gray-200"/>
                    <h3 className="mb-5 text-xl font-normal text-gray-200 dark:text-gray-400">
                    Your email has been sent!
                    </h3>

                    <div className="space-y-6">
                        <p className="text-base leading-relaxed text-gray-400 dark:text-gray-400">
                        Thanks for your message. I will be in touch as soon as I am able.
                        </p>
                    </div>
                   
                </div>
                </Modal.Body>
            </Modal>
        </>
        </div>
    )
    }